/**
 * Constantes de estilos reutilizáveis para o módulo public-event
 */

export const theme = {
    colors: {
        primary: '#1565C0',
        primaryDark: '#0D47A1',
        secondary: '#FF69B4',
        gradient: {
            start: '#6A5ACD',
            middle: '#695fac',
            end: '#FF69B4',
        },
        text: {
            primary: '#222222',
            secondary: '#424242',
            tertiary: '#757575',
        },
        background: {
            white: '#FFFFFF',
            lightGray: '#F3F3F3',
            lightPink: '#FFF5F5',
        },
        border: {
            pink: 'rgba(255, 85, 186, 0.5)',
            pinkDashed: '#FFB3BA',
        },
    },
    fonts: {
        primary: 'Manrope, sans-serif',
    },
    borderRadius: {
        small: 1,
        medium: 2,
        large: 12,
        round: '50%',
    },
    spacing: {
        header: {
            mobile: { padding: '250px', sm: '280px' },
            desktop: { padding: '260px', lg: '280px', xl: '300px' },
        },
    },
} as const;

// Helper para acessar valores de spacing de forma type-safe
export const headerPadding = {
    mobile: {
        xs: '210px',
        sm: '290px',
    },
    desktop: {
        md: '260px',
        lg: '280px',
        xl: '300px',
    },
} as const;

export const headerStyles = {
    container: {
        display: 'flex',
        alignItems: 'stretch',
        minHeight: { xs: 60, sm: 65, md: 70 },
        position: 'relative' as const,
        flexDirection: 'row' as const,
        overflow: 'hidden',
        width: '100%',
    },
    logoPanel: {
        bgcolor: theme.colors.background.lightGray,
        borderTopRightRadius: theme.borderRadius.large,
        display: 'flex',
        alignItems: 'center',
        px: { xs: 1, sm: 1.5, md: 2.5 },
        py: { xs: 1, sm: 1.2, md: 2 },
        zIndex: 2000,
        position: 'absolute' as const,
        width: { xs: 'auto', sm: 'auto', md: 'auto', lg: '420px' },
        maxWidth: { xs: '200px', sm: '280px', md: '380px', lg: '420px' },
        minHeight: { xs: '100%', sm: '100%', md: '102%' },
        maxHeight: { xs: '100%', sm: '100%', md: '102%' },
        justifyContent: { xs: 'center', md: 'center' },
        fontFamily: theme.fonts.primary,
        left: 0,
        top: 0,
    },
    gradientPanel: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 1.5, sm: 2, md: 4 },
        py: { xs: 1, sm: 1.2, md: 1.6 },
        background: `linear-gradient(90deg, ${theme.colors.gradient.start} 0%, ${theme.colors.gradient.middle} 60%, ${theme.colors.gradient.end} 100%)`,
        position: 'relative' as const,
        minHeight: { xs: 60, sm: 65, md: 70 },
        borderTopLeftRadius: theme.borderRadius.large,
        borderBottomLeftRadius: theme.borderRadius.large,
        fontFamily: theme.fonts.primary,
        overflow: { xs: 'hidden', md: 'visible' },
        width: { xs: '100%', md: 'auto' },
    },
} as const;

